import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8 col-xxl-8 col-sm-8 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-md-2 col-xxl-2 col-sm-2 mb-10" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Détails", -1)),
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, "Date d'envoi: " + _toDisplayString(_ctx.format_date(_ctx.notification?.createdAt)), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(_ctx.notification?.message), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-2 col-xxl-2 col-sm-2 mb-10" }, null, -1))
  ]))
}